/* Merch Express intro: one visit per tab session, with a bounded media wait. */
(function () {
  'use strict';
  var intro = window.MXIntro;
  var overlay = document.getElementById('mx-intro');
  if (!overlay) return;
  if (!intro || !intro.active) {
    mountStaticHomepageLogo();
    overlay.remove();
    return;
  }
  if (intro.wired) return;
  intro.wired = true;
  var root = document.documentElement;
  var hero = document.querySelector('[data-mx-hero]');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var timers = [];
  var inerted = [];
  var leaving = false;
  var restoreFocus = false;
  var previouslyFocused = document.activeElement;
  var targetLogo = null;
  var flightLayer = null;
  var flightAnimations = [];
  var logoLanded = false;
  var liveMarkPiece = null;
  var liveWordPiece = null;

  function later(fn, delay) { timers.push(setTimeout(fn, delay)); }
  function motionChange() { if (reduced.matches) intro.finish(); }

  function revealTargetLogo() {
    if (!targetLogo) return;
    targetLogo.classList.remove('mx-intro-logo-awaiting');
  }

  function removeFlightLayer() {
    if (!flightLayer) return;
    flightLayer.remove();
    flightLayer = null;
  }

  function prepareHomepagePiece(piece, className) {
    piece.removeAttribute('id');
    piece.removeAttribute('style');
    /* SVGElement.className is an SVGAnimatedString in Chromium and cannot be
       assigned like HTMLElement.className. setAttribute works for both. */
    piece.setAttribute('class', className);
    piece.setAttribute('aria-hidden', 'true');
    return piece;
  }

  function mountHomepageLogo(markPiece, wordPiece) {
    targetLogo = targetLogo || document.querySelector('[data-mx-intro-home-logo]');
    if (!targetLogo || !targetLogo.hasAttribute('data-mx-intro-home-logo')) return false;
    var markSlot = targetLogo.querySelector('[data-mx-intro-target-mark]');
    var wordSlot = targetLogo.querySelector('[data-mx-intro-target-word]');
    if (!markSlot || !wordSlot || !markPiece || !wordPiece) return false;

    markSlot.replaceChildren(prepareHomepagePiece(markPiece, 'mx-head__intro-mark'));
    wordSlot.replaceChildren(prepareHomepagePiece(wordPiece, 'mx-head__intro-word'));
    targetLogo.classList.add('mx-head__intro-logo--mounted');
    return true;
  }

  function mountStaticHomepageLogo() {
    var homeTarget = document.querySelector('[data-mx-intro-home-logo]');
    if (!homeTarget) return false;
    targetLogo = homeTarget;
    return mountHomepageLogo(
      overlay.querySelector('.mx-intro__mark'),
      overlay.querySelector('.mx-intro__wordmark-mark')
    );
  }

  function landLogo() {
    if (logoLanded) return;
    logoLanded = true;
    if (liveMarkPiece && liveWordPiece) {
      /* These are the original preloader nodes, not clones. Cancel their
         finished FLIP styles and reparent them synchronously into the navbar;
         the browser paints only the identical final placement. */
      flightAnimations.forEach(function (animation) { animation.cancel(); });
      flightAnimations.length = 0;
      mountHomepageLogo(liveMarkPiece, liveWordPiece);
      liveMarkPiece = null;
      liveWordPiece = null;
    }
    revealTargetLogo();
    removeFlightLayer();
    document.dispatchEvent(new CustomEvent('mx:intro:logo-landed'));
  }

  function partRect(base, x, y, width, height) {
    return {
      left: base.left + (base.width * x / 505),
      top: base.top + (base.height * y / 76),
      width: base.width * width / 505,
      height: base.height * height / 76
    };
  }

  function copyRect(element) {
    var rect = element.getBoundingClientRect();
    return { left: rect.left, top: rect.top, width: rect.width, height: rect.height };
  }

  function measurePostIntroRects(target, markSlot, wordSlot) {
    /* Measure the browser's actual final layout rather than estimating its
       scrollbar width. Overlay and classic scrollbars reserve space
       differently, which otherwise creates a small rightward correction. */
    var priorRootStyle = root.getAttribute('style');
    root.style.setProperty('overflow', 'auto', 'important');
    root.style.setProperty('scrollbar-gutter', 'stable', 'important');
    var result = {
      target: copyRect(target),
      mark: markSlot ? copyRect(markSlot) : null,
      word: wordSlot ? copyRect(wordSlot) : null
    };
    if (priorRootStyle === null) root.removeAttribute('style');
    else root.setAttribute('style', priorRootStyle);
    return result;
  }

  function makeFlightPiece(source, start, className) {
    var piece = source.cloneNode(true);
    piece.removeAttribute('id');
    piece.classList.add('mx-intro__flight-piece', className);
    piece.setAttribute('aria-hidden', 'true');
    piece.style.left = start.left + 'px';
    piece.style.top = start.top + 'px';
    piece.style.width = start.width + 'px';
    piece.style.height = start.height + 'px';
    flightLayer.appendChild(piece);
    return piece;
  }

  function takeFlightPiece(source, start, className) {
    /* The original node leaves the lockup for the flight layer. Hold its space
       with an invisible box of the same size, or everything below it (the
       "Make your mark move" line) jumps up into the gap while still visible. */
    var hold = document.createElement('span');
    hold.setAttribute('aria-hidden', 'true');
    hold.style.cssText = 'display:block;visibility:hidden;margin:0;padding:0;flex:none;' +
      'width:' + start.width + 'px;height:' + start.height + 'px;';
    if (source.parentNode) source.parentNode.insertBefore(hold, source);

    var piece = source;
    piece.removeAttribute('id');
    piece.classList.add('mx-intro__flight-piece', className);
    piece.setAttribute('aria-hidden', 'true');
    piece.style.left = start.left + 'px';
    piece.style.top = start.top + 'px';
    piece.style.width = start.width + 'px';
    piece.style.height = start.height + 'px';
    flightLayer.appendChild(piece);
    return piece;
  }

  function makeExactLandingPiece(source, destination) {
    var piece = source.cloneNode(true);
    piece.className = 'mx-intro__flight-exact';
    piece.removeAttribute('data-mx-intro-target');
    piece.removeAttribute('style');
    piece.setAttribute('aria-hidden', 'true');
    piece.style.left = destination.left + 'px';
    piece.style.top = destination.top + 'px';
    piece.style.width = destination.width + 'px';
    piece.style.height = destination.height + 'px';
    flightLayer.appendChild(piece);
    return piece;
  }

  function animatePiece(piece, start, destination) {
    var x = destination.left - start.left;
    var y = destination.top - start.top;
    var scaleX = destination.width / start.width;
    var scaleY = destination.height / start.height;
    var animation = piece.animate([
      { transform: 'translate3d(0,0,0) scale(1,1)' },
      { transform: 'translate3d(' + x + 'px,' + y + 'px,0) scale(' + scaleX + ',' + scaleY + ')' }
    ], {
      duration: 1050,
      easing: 'cubic-bezier(.77,0,.175,1)',
      fill: 'forwards'
    });
    flightAnimations.push(animation);
    return animation;
  }

  function animateColour(piece, from, to) {
    /* The leaf is excluded here and driven separately below: it shares the
       bar's own fill, so animating every path the same way marches the leaf
       through the exact colour the bar has at that instant, and a shape
       exactly the colour of what it sits on cannot be seen. */
    piece.querySelectorAll('path:not(.mx-intro__mark-leaf)').forEach(function (path) {
      flightAnimations.push(path.animate([
        { fill: from },
        { fill: from, offset: .22 },
        { fill: to }
      ], {
        duration: 1050,
        easing: 'cubic-bezier(.65,0,.35,1)',
        fill: 'forwards'
      }));
    });
  }

  function animateLeafColour(piece) {
    var leaf = piece.querySelector('.mx-intro__mark-leaf');
    if (!leaf) return;
    /* Cream to the mounted navbar's own orange (--mx-orange-deep) - never the bar's from/to, so
       the leaf stays legible against the bar for the whole flight rather
       than converging on the same colour partway through. */
    flightAnimations.push(leaf.animate([
      { fill: '#f5ede3' },
      { fill: '#f5ede3', offset: .22 },
      { fill: '#cb4803' }
    ], {
      duration: 1050,
      easing: 'cubic-bezier(.65,0,.35,1)',
      fill: 'forwards'
    }));
  }

  function animateLandingBlend(markPiece, wordPiece, exactPiece) {
    [markPiece, wordPiece].forEach(function (piece) {
      flightAnimations.push(piece.animate([
        { opacity: 1, filter: 'blur(0)', offset: 0 },
        { opacity: 1, filter: 'blur(0)', offset: .82, easing: 'cubic-bezier(.23,1,.32,1)' },
        { opacity: 0, filter: 'blur(1px)', offset: 1 }
      ], {
        duration: 1050,
        easing: 'linear',
        fill: 'forwards'
      }));
    });
    flightAnimations.push(exactPiece.animate([
      { opacity: 0, offset: 0 },
      { opacity: 0, offset: .82, easing: 'cubic-bezier(.23,1,.32,1)' },
      { opacity: 1, offset: 1 }
    ], {
      duration: 1050,
      easing: 'linear',
      fill: 'forwards'
    }));
  }

  function startLogoHandoff() {
    var markSource = overlay.querySelector('.mx-intro__mark');
    var wordSource = overlay.querySelector('.mx-intro__wordmark-mark');
    targetLogo = document.querySelector('[data-mx-intro-target]');
    if (!markSource || !wordSource || !targetLogo || typeof markSource.animate !== 'function') return false;

    var target = copyRect(targetLogo);
    var markStart = markSource.getBoundingClientRect();
    var wordStart = wordSource.getBoundingClientRect();
    if (target.width < 1 || target.height < 1 || markStart.width < 1 || wordStart.width < 1) return false;

    var isHomepageLogo = targetLogo.hasAttribute('data-mx-intro-home-logo');
    var markSlot = isHomepageLogo ? targetLogo.querySelector('[data-mx-intro-target-mark]') : null;
    var wordSlot = isHomepageLogo ? targetLogo.querySelector('[data-mx-intro-target-word]') : null;
    if (isHomepageLogo && (!markSlot || !wordSlot)) return false;

    /* Temporarily ask the browser for the exact layout it will use after the
       intro. Keep the target at that position during the flight, then remove
       the compensation in the same frame that the real layout takes over. */
    var activeTarget = target;
    var finalRects = measurePostIntroRects(targetLogo, markSlot, wordSlot);
    target = finalRects.target;
    var finalShiftX = target.left - activeTarget.left;
    /* The homepage keeps its actual SVGs in the fixed flight layer until the
       root layout is already final, so it needs no temporary navbar offset. */
    if (!isHomepageLogo && Math.abs(finalShiftX) > .01) {
      targetLogo.style.setProperty('--mx-intro-gutter-shift', finalShiftX + 'px');
      targetLogo.classList.add('mx-intro-logo-gutter');
    }

    var markEnd;
    var wordEnd;
    if (isHomepageLogo) {
      markEnd = finalRects.mark;
      wordEnd = finalRects.word;
    } else {
      /* logo_clean.svg is 505x76. These are its symbol and word regions. */
      markEnd = partRect(target, 0, 0, 114, 76);
      wordEnd = partRect(target, 134.05, 12, 371, 41.44);
    }

    flightLayer = document.createElement('div');
    flightLayer.className = 'mx-intro__flight';
    flightLayer.setAttribute('aria-hidden', 'true');
    document.body.appendChild(flightLayer);

    var markPiece;
    var wordPiece;
    var exactPiece = null;
    if (isHomepageLogo) {
      /* Move the actual preloader SVG nodes. They become the persistent
         homepage navbar logo at landLogo(), so there is no replacement frame. */
      markPiece = takeFlightPiece(markSource, markStart, 'mx-intro__flight-mark');
      wordPiece = takeFlightPiece(wordSource, wordStart, 'mx-intro__flight-word');
      liveMarkPiece = markPiece;
      liveWordPiece = wordPiece;
    } else {
      markPiece = makeFlightPiece(markSource, markStart, 'mx-intro__flight-mark');
      wordPiece = makeFlightPiece(wordSource, wordStart, 'mx-intro__flight-word');
      exactPiece = makeExactLandingPiece(targetLogo, target);
    }

    targetLogo.classList.add('mx-intro-logo-awaiting');
    root.classList.add('mx-intro-handoff');
    document.dispatchEvent(new CustomEvent('mx:intro:logo-handoff'));

    var movements = [
      animatePiece(markPiece, markStart, markEnd),
      animatePiece(wordPiece, wordStart, wordEnd)
    ];
    animateColour(markPiece, '#e55204', '#ffffff');
    animateColour(wordPiece, '#f7f3ec', '#ffffff');
    animateLeafColour(markPiece);
    if (exactPiece) animateLandingBlend(markPiece, wordPiece, exactPiece);

    var movementFinished = Promise.all(movements.map(function (animation) {
      return animation.finished.catch(function () {});
    }));
    if (isHomepageLogo) {
      /* Hold the finished flight artwork in place. intro.finish() first makes
         the page/scrollbar layout final, then cleanup atomically reparents
         these same nodes into the now-stable navbar. */
      movementFinished.then(function () {
        document.dispatchEvent(new CustomEvent('mx:intro:logo-arrived'));
      });
    } else {
      movementFinished.then(landLogo);
      // Fail-open for browsers that expose WAAPI but never settle finished.
      later(landLogo, 1120);
    }
    return true;
  }

  function leave() {
    if (leaving || !intro.active) return;
    leaving = true;
    restoreFocus = overlay.contains(document.activeElement);
    if (reduced.matches) { intro.finish(); return; }
    startLogoHandoff();
    root.classList.add('mx-intro-leaving');
    // Hand the page back as the curtain starts moving, together with the scroll
    // lock. Waiting for finish() leaves ~1.3s where the page scrolls but every
    // link and button is still dead.
    inerted.forEach(function (element) { element.inert = false; });
    inerted.length = 0;
    // Keep the class through the longest staggered hero transition, preventing a snap.
    later(intro.finish, 1320);
  }
  intro.cleanup = function () {
    timers.forEach(clearTimeout);
    if (liveMarkPiece && liveWordPiece) {
      landLogo();
    } else {
      flightAnimations.forEach(function (animation) { animation.cancel(); });
      flightAnimations.length = 0;
      revealTargetLogo();
      removeFlightLayer();
    }
    if (targetLogo) {
      targetLogo.classList.remove('mx-intro-logo-gutter');
      targetLogo.style.removeProperty('--mx-intro-gutter-shift');
    }
    inerted.forEach(function (element) { element.inert = false; });
    reduced.removeEventListener('change', motionChange);
    // Do not steal focus on an automatic entrance.
    if (restoreFocus || overlay.contains(document.activeElement)) {
      var target = previouslyFocused && previouslyFocused !== document.body && previouslyFocused.isConnected ? previouslyFocused : hero;
      if (target) target.focus({ preventScroll: true });
    }
  };
  if (!hero || (window.Shopify && window.Shopify.designMode) || reduced.matches) {
    mountStaticHomepageLogo();
    intro.finish(); return;
  }
  Array.prototype.forEach.call(document.body.children, function (element) {
    if (element === overlay || /^(SCRIPT|STYLE|LINK)$/.test(element.tagName) || element.inert) return;
    element.inert = true;
    inerted.push(element);
  });
  reduced.addEventListener('change', motionChange);

  function imageReady(url) {
    return new Promise(function (resolve) {
      var image = new Image();
      image.onload = image.onerror = resolve;
      image.src = url;
      if (image.complete) resolve();
      if (image.decode) image.decode().then(resolve, resolve);
    });
  }
  var slide = hero.querySelector('[data-mx-hero-slide]');
  if (slide) slide.setAttribute('data-mx-intro-landed', '');
  var waits = [];
  if (slide) {
    // Read the actual first-slide image; never duplicate a merchant-controlled URL.
    // Phones render the smaller variant (see the 700px rule in mx-home.css);
    // waiting on the desktop URL there would download a second, larger copy.
    var background = '';
    if (window.matchMedia('(max-width: 700px)').matches) {
      background = getComputedStyle(slide).getPropertyValue('--mx-hero-image-sm');
    }
    if (!background || !background.trim()) {
      background = getComputedStyle(slide).getPropertyValue('--mx-hero-image');
    }
    var match = background.match(/url\(["']?(.*?)["']?\)/);
    if (match) waits.push(imageReady(match[1]));
    slide.querySelectorAll('img').forEach(function (image) {
      if (image.decode) waits.push(image.decode().catch(function () {}));
    });
  }
  /* The wordmark and "Make your mark move" finish arriving at ~2.3s; holding to
     3.5s gives them about a second fully on screen before the handoff. At 2.5s
     the tagline was only fully visible for ~0.2s. */
  var minimum = new Promise(function (resolve) {
    later(resolve, Math.max(0, 3500 - (performance.now() - intro.started)));
  });
  var ready = Promise.race([
    Promise.all(waits),
    new Promise(function (resolve) { later(resolve, Math.max(0, 5000 - (performance.now() - intro.started))); })
  ]);
  Promise.all([minimum, ready]).then(leave);
})();
